import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "flex flex--justify-space-between mb-40" }
const _hoisted_4 = { class: "flex flex--gap-large flex--align-center iota" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " View: ", -1 /* HOISTED */)
const _hoisted_6 = {
  key: 0,
  class: "mb-64"
}
const _hoisted_7 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageLoaderComponent = _resolveComponent("PageLoaderComponent")
  const _component_DiscussionComponent = _resolveComponent("DiscussionComponent")
  const _component_DiscussionListComponent = _resolveComponent("DiscussionListComponent")
  const _component_DiscussionModalComponent = _resolveComponent("DiscussionModalComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($data.loading)
          ? (_openBlock(), _createBlock(_component_PageLoaderComponent, { key: 0 }))
          : ($options.active_discussion)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  class: "back-to mb-24",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.clearActiveDiscussion && $options.clearActiveDiscussion(...args)))
                }, " Back to discussions "),
                _createVNode(_component_DiscussionComponent, {
                  "project-complete": $props.project.project_status === 'completed' || $props.project.project_status === 'terminated',
                  discussion: $options.active_discussion,
                  comments: $data.comments_by_discussion_id[ $options.active_discussion.id ],
                  onRefreshComments: $options.refreshData
                }, null, 8 /* PROPS */, ["project-complete", "discussion", "comments", "onRefreshComments"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  ($props.project.project_status !== 'completed' || $props.project.project_status === 'terminated')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button button--large button--fill",
                        onClick: _cache[1] || (_cache[1] = $event => ($data.show_discussion_modal = true))
                      }, " Start a new discussion "))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("button", {
                      class: _normalizeClass(["iota a", {'a--no-underline': $data.filter !== null}]),
                      onClick: _cache[2] || (_cache[2] = $event => ($data.filter = null))
                    }, " All ", 2 /* CLASS */),
                    ($data.discussions.find( discussion => discussion.type === 'discussion' ))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(["iota a", {'a--no-underline': $data.filter !== 'discussion'}]),
                          onClick: _cache[3] || (_cache[3] = $event => ($data.filter = 'discussion'))
                        }, " Discussions ", 2 /* CLASS */))
                      : _createCommentVNode("v-if", true),
                    ($data.discussions.find( discussion => discussion.type === 'asset' ))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: _normalizeClass(["iota a", {'a--no-underline': $data.filter !== 'asset'}]),
                          onClick: _cache[4] || (_cache[4] = $event => ($data.filter = 'asset'))
                        }, " Assets ", 2 /* CLASS */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                ($data.discussions && $data.discussions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_DiscussionListComponent, {
                        discussions: $options.filtered_discussions,
                        onSetActiveDiscussion: $options.setActiveDiscussionId
                      }, null, 8 /* PROPS */, ["discussions", "onSetActiveDiscussion"])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_7, " There aren't any discussions on this project. "))
              ]))
      ]),
      _: 1 /* STABLE */
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($data.show_discussion_modal)
            ? (_openBlock(), _createBlock(_component_DiscussionModalComponent, {
                key: 0,
                onCloseModal: _cache[5] || (_cache[5] = $event => ($data.show_discussion_modal = false)),
                onDiscussionCreated: $options.loadNewDiscussion
              }, null, 8 /* PROPS */, ["onDiscussionCreated"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]))
  ], 64 /* STABLE_FRAGMENT */))
}